import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'v1' },
  {
    path: 'v1',
    loadChildren: () => import('./v1/v1.routes').then((module) => module.V1_ROUTES),
  },
  { path: '**', redirectTo: 'v1' },
];
